import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["count", "offsetMin", "offsetMax"],
    _excluded2 = ["count", "type", "offsetMin", "offsetMax", "dataGrouping", "children"];
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getEventsConfig, useChart } from 'react-jsx-highcharts';

var RangeSelectorButton = function RangeSelectorButton(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 1 : _ref$count,
      _ref$offsetMin = _ref.offsetMin,
      offsetMin = _ref$offsetMin === void 0 ? 0 : _ref$offsetMin,
      _ref$offsetMax = _ref.offsetMax,
      offsetMax = _ref$offsetMax === void 0 ? 0 : _ref$offsetMax,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var props = _objectSpread({
    count: count,
    offsetMin: offsetMin,
    offsetMax: offsetMax
  }, restProps);

  var chart = useChart();
  useEffect(function () {
    var button = getButtonIndex(props, chart);
    if (button > -1) return; // Button already present

    var count = props.count,
        type = props.type,
        offsetMin = props.offsetMin,
        offsetMax = props.offsetMax,
        dataGrouping = props.dataGrouping,
        text = props.children,
        rest = _objectWithoutProperties(props, _excluded2);

    var opts = {
      count: count,
      type: type,
      offsetMin: offsetMin,
      offsetMax: offsetMax,
      dataGrouping: dataGrouping,
      text: text,
      events: getEventsConfig(rest)
    };
    addButton(opts, chart);
    return function () {
      try {
        removeButton(props, chart);
      } catch (_unused) {// ignore as chart might have been already unmounted
      }
    };
  }, []);
  return null;
};

var getButtons = function getButtons(chart) {
  var chartObj = chart.object;

  if (chartObj && chartObj.options) {
    var _chartObj$options$ran = chartObj.options.rangeSelector.buttons,
        buttons = _chartObj$options$ran === void 0 ? [] : _chartObj$options$ran;
    return buttons;
  }

  return [];
};

var getButtonIndex = function getButtonIndex(props, chart) {
  var count = props.count,
      type = props.type;
  return getButtons(chart).findIndex(function (b) {
    return b.count === count && b.type === type;
  });
};

var addButton = function addButton(config, chart) {
  // Add button to array
  var buttons = [].concat(_toConsumableArray(getButtons(chart)), [config]);
  updateRangeSelectorButtons(buttons, chart);
};

var removeButton = function removeButton(props, chart) {
  var button = getButtonIndex(props);
  if (button === -1) return; // Remove button from array

  var buttons = _toConsumableArray(getButtons());

  buttons.splice(button, 1);
  updateRangeSelectorButtons(buttons, chart);
};

var updateRangeSelectorButtons = function updateRangeSelectorButtons(config, chart) {
  chart.update({
    rangeSelector: {
      buttons: config
    }
  });
};

RangeSelectorButton.propTypes = {
  count: PropTypes.number,
  type: PropTypes.oneOf(['millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'ytd', 'all']),
  offsetMin: PropTypes.number.isRequired,
  offsetMax: PropTypes.number.isRequired,
  dataGrouping: PropTypes.object
};
export default RangeSelectorButton;